import {ImageProcessingNodes} from "@cm/image-processing-nodes"
import {Descriptor} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-descriptor"
import {RefCountableBase} from "@cm/utils"

export class ImageOpImgProc extends RefCountableBase {
    readonly _imageOpKind = "imgproc" as const

    constructor(
        readonly descriptor: Descriptor,
        readonly node: ImageProcessingNodes.ImageNode,
    ) {
        super()
    }
}
